/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AdminTeacherPaymentDTOQueryResultDTO,
  AdminTeacherPaymentsGetTeacherPaymentsParams,
  FilterModelDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminTeacherPaymentsGetTeacherPayments = (
    organizationId: number,
    semesterId: number,
    filterModelDTO: FilterModelDTO[],
    params?: AdminTeacherPaymentsGetTeacherPaymentsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminTeacherPaymentDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminTeacherPayments/list/${semesterId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAdminTeacherPaymentsGetTeacherPaymentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeacherPaymentsGetTeacherPayments>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminTeacherPaymentsGetTeacherPaymentsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminTeacherPaymentsGetTeacherPayments>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminTeacherPaymentsGetTeacherPaymentsParams}, TContext> => {
    
const mutationKey = ['adminTeacherPaymentsGetTeacherPayments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTeacherPaymentsGetTeacherPayments>>, {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminTeacherPaymentsGetTeacherPaymentsParams}> = (props) => {
          const {organizationId,semesterId,data,params} = props ?? {};

          return  adminTeacherPaymentsGetTeacherPayments(organizationId,semesterId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminTeacherPaymentsGetTeacherPaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof adminTeacherPaymentsGetTeacherPayments>>>
    export type AdminTeacherPaymentsGetTeacherPaymentsMutationBody = FilterModelDTO[]
    export type AdminTeacherPaymentsGetTeacherPaymentsMutationError = ErrorType<unknown>

    export const useAdminTeacherPaymentsGetTeacherPayments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeacherPaymentsGetTeacherPayments>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminTeacherPaymentsGetTeacherPaymentsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTeacherPaymentsGetTeacherPayments>>,
        TError,
        {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminTeacherPaymentsGetTeacherPaymentsParams},
        TContext
      > => {

      const mutationOptions = getAdminTeacherPaymentsGetTeacherPaymentsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    